import { Container, Flex, Text, Heading, Box } from "@chakra-ui/react";
import React from "react";
import MemberHeroSection from "@/components/membership/MemberHeroSection";

const linksData = [
	{
		id: "circular-standardised-approach",
		date: "27th June 2024",
		text: "Participation by Non-Resident Indians (NRIs), Overseas Citizens of India (OCIs) and Resident Indian (RI) individuals in SEBI registered FPIs based in International Financial Services Centres in India",
		link: "https://static.levocdn.com/WGLBUT82/Circular-IFSCNRI27062024Final1-YhE0TNygCBPY.pdf",
	},
];

const SebiCircular: React.FC = () => (
	<Flex direction="column" rowGap="20px">
		<MemberHeroSection
			title={
				<Heading
					as="h1"
					variant="headingText"
					color="text.headingWhite"
					fontSize={{ xs: "36px", sm: "60px", md: "74px" }}
					textAlign={{ xs: "left", sm: "left" }}
				>
					IFSCA: NRI/OCI/RI Investment Guidelines
				</Heading>
			}
			type="about-us"
		/>
		<Container
			maxW="container.xl"
			pt={{ xs: "50px", md: "50px" }}
			pb={{ xs: "50px", md: "50px" }}
			as="section"
			id="info"
			scrollMarginTop="140px"
		>
			<Flex direction="column" gap="2">
				<Box mb="40px">
					<Heading as="h4" mb="22px">
						SEBI Circular Resources
					</Heading>
				</Box>
				<Box>
					{linksData.map((item) => (
						<Flex
							key={item.id}
							direction={{ base: "column", md: "row" }}
							cursor="pointer"
							gap={{ md: "5" }}
							onClick={() => {
								if (item?.link) {
									window.open(item?.link, "_blank");
								}
							}}
						>
							<Flex minWidth="200px">
								<Text
									cursor="pointer"
									//   variant="infoText"
									variant="heroDesc"
									color="text.mediumBlackAlpha"
									_hover={{
										textDecoration: "underline",
									}}
								>
									{item.date}
								</Text>
								<Text
									display={{ base: "block", md: "none" }}
									cursor="pointer"
									//   variant="infoText"
									variant="heroDesc"
									color="text.mediumBlackAlpha"
									_hover={{
										textDecoration: "underline",
									}}
								>
									:&nbsp;
								</Text>
							</Flex>
							<Flex>
								<Text
									display={{ base: "none", md: "block" }}
									cursor="pointer"
									//   variant="infoText"
									variant="heroDesc"
									color="text.mediumBlackAlpha"
									_hover={{
										textDecoration: "underline",
									}}
								>
									:&nbsp;
								</Text>
								<Text
									cursor="pointer"
									//   variant="infoText"
									variant="heroDesc"
									color="text.mediumBlackAlpha"
									_hover={{
										textDecoration: "underline",
									}}
								>
									{item.text}
								</Text>
							</Flex>
						</Flex>
					))}
				</Box>
			</Flex>
		</Container>
	</Flex>
);

export default SebiCircular;
